import DOMPurify from 'dompurify';

export function getSafeInnerHtml(html) {
  DOMPurify.setConfig({
    ADD_ATTR: ['target']
  });

  return {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(html)
    }
  };
}

export function isHtmlEmpty(htmlString) {
  if (!htmlString) return true;

  // DOMParser kullanarak HTML string'ini parse et
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');

  // TextContent'i kullanarak tüm etiketleri ve boşluk karakterlerini temizle
  const textContent = doc.body.textContent || '';

  // Trim fonksiyonu ile baştaki ve sondaki boşlukları temizle
  const isTextEmpty = textContent.trim() === '';

  // İçerik sadece boş paragraflar, boşluklar veya yeni satır karakterleri içeriyorsa,
  // true (boş) değerini döndür
  return isTextEmpty;
}
